export const log = (...args: any) => {
  if (localStorage.getItem('logEnabled')) {
    // eslint-disable-next-line no-console
    console.log(...args, new Error().stack!.split('\n')[2].trim())
  }
}
